<ion-content class="bg-color ion-content apicatalouge" style="height: 900px;">
  <div class="content-grid">
    <div class="m-content">
      <div class="m-body2">
        <div class="scroll-height">
          <mat-grid-list cols="2" rowHeight="900px">
            <!-- <div class="row"> -->
            <mat-grid-tile>
              <div class="calendar-div">
                <mat-calendar [dateClass]="dateClass" [(selected)]="selected" #calendar
                  (selectedChange)="onSelect($event)"></mat-calendar>
              </div>
              <div class="selected-div">
                <p *ngIf="datesToHighlight.length == 0" style="font-size: 12px;">{{selected1}}</p>
                <p *ngFor="let item of datesToHighlight" style="font-size: 12px;">
                  {{item}}
                </p>
              </div>


            </mat-grid-tile>
            <mat-grid-tile class="schedule-select">
              <form [formGroup]="intervalForm" (ngSubmit)="submitInterval()">
                <mat-list role="list">
                  <mat-label class="labelCheck">Presets</mat-label>
                  <mat-list-item role="listitem" style="margin-top: 10px;">
                    <mat-form-field appearance="fill">
                      <mat-label class="cron-select">Choose a preset:</mat-label>
                      <mat-select class="cron-select" (selectionChange)="presetChange($event)" formControlName="every">
                        <mat-option *ngFor="let item of cronTypes" [value]="item.id">{{item.value}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </mat-list-item>

                  <mat-label class="labelCheck"
                    *ngIf="cronType == 5 || cronType == 6 || cronType == 7 || cronType == 8">Hours/Day</mat-label>
                  <mat-list-item role="listitem" *ngIf="cronType == 5 || cronType == 9 || cronType == 10"
                    class="cron-select-wrap" lines="none">
                    <mat-form-field appearance="fill" *ngIf="cronType == 5">
                      <mat-label class="cron-select">on week day</mat-label>
                      <mat-select class="cron-select day-value" formControlName="week"
                        (selectionChange)="changeWeekDay($event)">
                        <mat-option *ngFor="let item of dayValues" [value]="item.id">{{item.value}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" *ngIf="cronType == 9 || cronType == 10">
                      <mat-label class="cron-select">on week day</mat-label>
                      <mat-select class="cron-select day-value" formControlName="week"
                        (selectionChange)="changeWeekDay($event)">
                        <mat-option *ngFor="let item of dayValueForHr" [value]="item.id">{{item.value}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </mat-list-item>
                  <mat-list-item *ngIf="cronType == 8" class="cron-select-wrap" lines="none">
                    <mat-form-field appearance="fill">
                      <mat-label class="cron-select" *ngIf="cronType == 8">of month</mat-label>
                      <!-- <mat-select class="cron-select day-of-month-value" *ngIf="cronType == 6" formControlName="monthValue" (selectionChange)="changeMonth($event)">
                        <mat-option *ngFor="let item of sixMonth" [value]="item.id">{{item.value}}</mat-option>
                      </mat-select> -->
                      <mat-select class="cron-select  day-of-month-value" *ngIf="cronType == 8"
                        formControlName="monthValue" (selectionChange)="changeMonth($event)">
                        <mat-option *ngFor="let item of monthValues" [value]="item.id">{{item.value}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                  </mat-list-item>
                  <div style="display: flex;" *ngIf="cronType == 3">
                    <mat-list role="list">
                      <mat-list-item role="listitem">
                        <mat-form-field appearance="fill">
                          <mat-label class="cron-select">Date Type:</mat-label>
                          <mat-select class="cron-select" [(ngModel)]="_DateValue" (selectionChange)="changeDateType($event)"
                            formControlName="dateType">
                            <mat-option *ngFor="let item of dateType" [ngValue]="item.id" [value]="item.id">{{item.value}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-list-item>
                    </mat-list>
                  </div>
                  <mat-list-item *ngIf="(cronType == 3 && _DateValue == 1) || cronType == 6 || cronType == 7 || cronType == 8" class="cron-select-wrap"
                    lines="none">
                    <mat-form-field appearance="fill">
                      <mat-label class="cron-select" *ngIf="(cronType == 3 && _DateValue == 1) || cronType == 6 || cronType == 7 || cronType == 8">on the
                        date</mat-label>
                      <mat-select class="cron-select  day-of-month-value" formControlName="everyDate"
                        (selectionChange)="changeDate($event)">
                        <mat-option *ngFor="let item of dayOfMonthValues" [value]="item">{{item}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </mat-list-item>
                  <mat-list-item *ngIf="cronType == 11" class="cron-select-wrap" lines="none">
                    <div style="display: flex;">
                      <mat-form-field appearance="fill">
                        <mat-label class="cron-select">Month from</mat-label>
                        <mat-select class="cron-select  day-of-month-value" formControlName="monthFrom"
                          (selectionChange)="changeMonth($event,'')">
                          <mat-option [value]="0">0</mat-option>
                          <mat-option *ngFor="let item of monthID" [value]="item">{{item}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label class="cron-select">Month to</mat-label>
                        <mat-select class="cron-select  day-of-month-value" formControlName="monthTo"
                          (selectionChange)="changeMonth($event,'')">
                          <mat-option [value]="0">0</mat-option>
                          <mat-option *ngFor="let item of monthID" [value]="item">{{item}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </mat-list-item>
                  <mat-list-item *ngIf="(cronType == 3 && _DateValue == 2) || cronType == 11" class="cron-select-wrap" lines="none">
                    <div style="display: flex;">
                      <mat-form-field appearance="fill">
                        <mat-label class="cron-select">Date from</mat-label>
                        <mat-select class="cron-select  day-of-month-value" formControlName="everyDateFrom"
                          (selectionChange)="changeDate($event,'')">
                          <mat-option [value]="0">0</mat-option>
                          <mat-option *ngFor="let item of dayOfMonthValues" [value]="item">{{item}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label class="cron-select">Date to</mat-label>
                        <mat-select class="cron-select  day-of-month-value" formControlName="everyDateTo"
                          (selectionChange)="changeDate($event,'')">
                          <mat-option [value]="0">0</mat-option>
                          <mat-option *ngFor="let item of dayOfMonthValues" [value]="item">{{item}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </mat-list-item>
                  <div style="display: flex;" *ngIf="cronType == 3">
                    <mat-list role="list">
                      <mat-list-item role="listitem">
                        <mat-form-field appearance="fill">
                          <mat-label class="cron-select">Hours Type:</mat-label>
                          <mat-select class="cron-select" [(ngModel)]="_hourValue" (selectionChange)="changeHourType($event)"
                            formControlName="hourType">
                            <mat-option *ngFor="let item of hourType" [ngValue]="item.id" [value]="item.id">{{item.value}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-list-item>
                    </mat-list>
                  </div>
                  <mat-list-item *ngIf="cronType == 3 || cronType == 11" class="cron-select-wrap" lines="none">
                    <div style="display: flex;" *ngIf="_hourValue == 2">
                      <mat-form-field appearance="fill">
                        <mat-label class="cron-select">Hour from</mat-label>
                        <mat-select class="cron-select  day-of-month-value" formControlName="everyHourFrom"
                          (selectionChange)="changeHour($event,'')">
                          <mat-option *ngFor="let item of hourValues" [value]="item">{{item}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label class="cron-select">Hour to</mat-label>
                        <mat-select class="cron-select  day-of-month-value" formControlName="everyHourTo"
                          (selectionChange)="changeHour($event,'')">
                          <mat-option *ngFor="let item of hourValues" [value]="item">{{item}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div style="display: flex;" *ngIf="_hourValue == 1">
                      <!-- <mat-list-item class="cron-select-wrap" lines="none"> -->
                      <mat-form-field appearance="fill">
                        <mat-label class="cron-select" *ngIf="cronType >= 2">At hour</mat-label>
                        <mat-select class="cron-select  day-of-month-value" formControlName="everyHour"
                          (selectionChange)="changeHour($event,'')">
                          <mat-option *ngFor="let item of hourValues" [value]="item">{{item}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!-- </mat-list-item> -->
                    </div>
                  </mat-list-item>
                  <mat-list-item *ngIf="(cronType == 3 && _hourValue == 2) || cronType == 11" class="cron-select-wrap" lines="none">
                    <div style="display: flex;">
                      <mat-form-field appearance="fill">
                        <mat-label class="cron-select">Min from</mat-label>
                        <mat-select class="cron-select  day-of-month-value" formControlName="everyMinuteFrom"
                          (selectionChange)="changeMin($event,'')">
                          <mat-option *ngFor="let item of minuteValues" [value]="item">{{item}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label class="cron-select">Min to</mat-label>
                        <mat-select class="cron-select  day-of-month-value" formControlName="everyMinuteTo"
                          (selectionChange)="changeMin($event,'')">
                          <mat-option *ngFor="let item of minuteValues" [value]="item">{{item}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </mat-list-item>

                  <mat-list-item *ngIf="cronType >= 2 && cronType != 3 && cronType != 11" class="cron-select-wrap"
                    lines="none">
                    <mat-form-field appearance="fill">
                      <mat-label class="cron-select" *ngIf="cronType >= 2">At hour</mat-label>
                      <mat-select class="cron-select  day-of-month-value" formControlName="everyHour"
                        (selectionChange)="changeHour($event,'')">
                        <mat-option *ngFor="let item of hourValues" [value]="item">{{item}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                  </mat-list-item>

                  <mat-list-item class="cron-select-wrap" lines="none" *ngIf="cronType != 3 && cronType != 11">
                    <!--  *ngIf="cronType == 1" -->
                    <mat-form-field appearance="fill">
                      <mat-label class="cron-select">Mins</mat-label>
                      <mat-select class="cron-select  day-of-month-value" formControlName="everyMinute"
                        (selectionChange)="changeMin($event,'')">
                        <mat-option *ngFor="let item of minuteValues" [value]="item">{{item}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                  </mat-list-item>

                  <mat-list-item class="cron-select-wrap" lines="none" *ngIf="cronType == 3 && _hourValue == 1">
                    <!--  *ngIf="cronType == 1" -->
                    <mat-form-field appearance="fill">
                      <mat-label class="cron-select">Mins</mat-label>
                      <mat-select class="cron-select  day-of-month-value" formControlName="everyMinute"
                        (selectionChange)="changeMin($event,'')">
                        <mat-option *ngFor="let item of minuteValues" [value]="item">{{item}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                  </mat-list-item>

                  <mat-label class="labelCheck">Months - If you are not selecting the month service will run every
                    month</mat-label>
                  <mat-list-item class="cron-select-wrap" lines="none">
                    <ion-label class="schedular-label">Jan</ion-label>
                    <ion-label class="schedular-label">Feb</ion-label>
                    <ion-label class="schedular-label">Mar</ion-label>
                    <ion-label class="schedular-label">Apr</ion-label>
                    <ion-label class="schedular-label">May</ion-label>
                    <ion-label class="schedular-label">Jun</ion-label>
                  </mat-list-item>
                  <mat-list-item class="cron-select-wrap" lines="none">
                    <span *ngFor="let item of monthIds;let i = index">
                      <input type="checkbox" class="inputCheck1" [checked]="getMonthChecked(item)"
                        (change)="onMonthChange(item);selectedMonthId = i" value="item" [attr.disabled]="isDisabled ? true : null">
                    </span>
                  </mat-list-item>
                  <mat-list-item class="cron-select-wrap" lines="none">
                    <mat-label class="schedular-label">Jul</mat-label>
                    <mat-label class="schedular-label">Aug</mat-label>
                    <mat-label class="schedular-label">Sep</mat-label>
                    <mat-label class="schedular-label">Oct</mat-label>
                    <mat-label class="schedular-label">Nov</mat-label>
                    <mat-label class="schedular-label">Dec</mat-label>
                  </mat-list-item>
                  <mat-list-item class="cron-select-wrap" lines="none">
                    <span *ngFor="let item of monthIds1;let i = index">
                      <input type="checkbox" class="inputCheck1" [checked]="getMonthChecked(item)"
                        (change)="onMonthChange(item);selectedMonthId = i" value="item" [attr.disabled]="isDisabled ? true : null">
                    </span>
                  </mat-list-item>

                  <mat-label class="labelCheck">Days of week - If you are not selecting the days service will run every
                    day</mat-label>
                  <mat-list-item class="cron-select-wrap" lines="none">
                    <mat-label class="schedular-label1">S</mat-label>
                    <mat-label class="schedular-label1">M</mat-label>
                    <mat-label class="schedular-label1">T</mat-label>
                    <mat-label class="schedular-label1">W</mat-label>
                    <mat-label class="schedular-label1">T</mat-label>
                    <mat-label class="schedular-label1">F</mat-label>
                    <mat-label class="schedular-label1">S</mat-label>
                  </mat-list-item>
                  <mat-list-item *ngIf="cronType == 1 || cronType == 2 || cronType == 4" class="cron-select-wrap1" lines="none">
                    <span *ngFor="let item of weekdays;let i = index">
                      <input type="checkbox" [checked]="getChecked(item)" (change)="onDayChange(item);selectedDays = i"
                        value="item" [attr.disabled]="isDisabled ? true : null">
                    </span>

                  </mat-list-item>
                  <mat-list-item *ngIf="dayValue != '6,0' && dayValue != '1-5' && (cronType != 1 && cronType != 2 && cronType != 4)"
                    class="cron-select-wrap" lines="none">
                    <input type="checkbox" [checked]="dayValue == 1" name="checkbox1" (click)="checkDayBox(0)" value="0" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 2" class="inputCheck" name="checkbox1"
                      (click)="checkDayBox(1)" value="1" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 3" class="inputCheck" name="checkbox1"
                      (click)="checkDayBox(2)" value="2" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 4" class="inputCheck" name="checkbox1"
                      (click)="checkDayBox(3)" value="3" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 5" class="inputCheck" name="checkbox1"
                      (click)="checkDayBox(4)" value="4" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 6" class="inputCheck" name="checkbox1"
                      (click)="checkDayBox(5)" value="5" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 7" class="inputCheck" name="checkbox1"
                      (click)="checkDayBox(6)" value="6" [attr.disabled]="isDisabled ? true : null">
                  </mat-list-item>
                  <mat-list-item *ngIf="dayValue == '6,0' && (cronType != 1 && cronType != 2 && cronType != 4)" class="cron-select-wrap" lines="none">
                    <input type="checkbox" [checked]="dayValue == '6,0'" name="checkbox1" value="Sunday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 2" class="inputCheck" name="checkbox1" value="Monday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 3" class="inputCheck" name="checkbox1" value="Tuesday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 4" class="inputCheck" name="checkbox1"
                      value="Wednesday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 5" class="inputCheck" name="checkbox1"
                      value="Thrusday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 6" class="inputCheck" name="checkbox1" value="Friday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == '6,0'" class="inputCheck" name="checkbox1"
                      value="Saturday" [attr.disabled]="isDisabled ? true : null">
                  </mat-list-item>
                  <mat-list-item *ngIf="dayValue == '1-5' && (cronType != 1 && cronType != 2 && cronType != 4)" class="cron-select-wrap" lines="none">
                    <input type="checkbox" [checked]="dayValue == 1" name="checkbox1" value="Sunday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == '1-5'" class="inputCheck" name="checkbox1"
                      value="Monday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == '1-5'" class="inputCheck" name="checkbox1"
                      value="Tuesday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == '1-5'" class="inputCheck" name="checkbox1"
                      value="Wednesday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == '1-5'" class="inputCheck" name="checkbox1"
                      value="Thrusday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == '1-5'" class="inputCheck" name="checkbox1"
                      value="Friday" [attr.disabled]="isDisabled ? true : null">
                    <input type="checkbox" [checked]="dayValue == 7" class="inputCheck" name="checkbox1"
                      value="Saturday" [attr.disabled]="isDisabled ? true : null">
                  </mat-list-item>
                </mat-list>

                <ion-row>
                  <ion-col>
                    <button type="submit" mat-raised-button class="submitButton">Done</button>
                  </ion-col>
                </ion-row>
              </form>
            </mat-grid-tile>
            <!-- </div> -->
          </mat-grid-list>


        </div>
      </div>
    </div>
  </div>

</ion-content>